// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const breakpoints: Styleguide["breakpoints"] = {};

export default breakpoints;
